/**
 * Medidas y colores sacados de las maquetas de Jorge (2 nov 2026: Mi mascota, Inicio y Tienda),
 * pasadas a puntos de un iPhone de 390 de ancho (la maqueta mide 700 px de marco → 1,795 px por punto).
 * Letra: Figtree, la que más se parece a la de las maquetas.
 */
export const M = {
  letra: "'Figtree', 'Hanken Grotesk', sans-serif",
  titulos: "'Figtree', 'Hanken Grotesk', sans-serif",
  tinta: '#1E2A27',
  gris: '#5E6460',
  verde: '#1F6A66',
  verdeBoton: '#0E5F5B',
  coral: '#B4472A',
  dorado: '#E9A43A',
  fondo: '#FAF4EC',
  tarjeta: '#FFFDFA',
  interior: '#F8F3EC',
  borde: '#EEE7DD',
  sombra: '0 1px 2px rgba(60,45,30,.05), 0 6px 16px -10px rgba(60,45,30,.25)',
};
